export default {
  data () {
    return {
      sitearr: [
        {
          id: 0,
          value: '全部'
        },
        {
          id: 1,
          value: '自站'
        },
        {
          id: 2,
          value: '租站'
        },
      ],
    }
  },
}